export const minerDeclension = (count: number): string => {
  if (!count || (count % 10 === 1 && count % 100 !== 11)) {
    return 'майнер';
  }

  if (count % 10 >= 2 && count % 10 <= 4 && !(count % 100 >= 12 && count % 100 <= 14)) {
    return 'майнера';
  }

  return 'майнеров';
};
